export default "__VITE_ASSET__36526140__"